import PropTypes from "prop-types";

import { ReactSelect } from "@hydra/atom/components";
import { components } from "react-select";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import { SvgIcon } from "@/components/common";
import {
  selectActiveApp,
  setActiveApp,
  selectApps,
} from "@/store/appSlice";
import { useUser } from "@/hooks";
import { VENDOR_USER_TYPE } from "@/utils/userTypes";
import { getTestId } from "@/utils/helpers";

function DropdownIndicator() {
  return (
    <div className="dropdown-indicator">
      <SvgIcon icon="arrow-down-icon" />
    </div>
  );
}

function ValueContainer({ children, ...props }) {
  return (
    <components.ValueContainer {...props}>
      <img className="account-img" src={props.getValue()[0]?.image} alt="" />
      <div className="value-container-labels">
        {children}
        <div className="account-label">{props.getValue()[0]?.label}</div>
      </div>
    </components.ValueContainer>
  );
}

ValueContainer.propTypes = {
  getValue: PropTypes.func.isRequired,
  children: PropTypes.array.isRequired,
};

function CustomOption(props) {
  const { data, label, testId } = props;
  return (
    <div data-testid={getTestId(`${testId}-Option`)}>
      <components.Option {...props}>
        <img className="account-img" src={data.image} alt="" />
        {label}
      </components.Option>
    </div>
  );
}

CustomOption.propTypes = {
  data: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
};

function Input(props) {
  const { isHidden, getClassNames, ...rest } = props;
  if (isHidden) return null;

  return <components.Input {...rest} />;
}

Input.propTypes = {
  isHidden: PropTypes.bool.isRequired,
};

export default function SwitchAccountDropdown() {
  const apps = useSelector(selectApps);
  const activeApp = useSelector(selectActiveApp);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { userType } = useUser();

  const handleChangeActiveApp = (option) => {
    dispatch(setActiveApp(option));

    switch (option.value) {
      case "Admin":
        navigate("/admin/tasks");
        break;

      case "FacilityManagement": {
        if (userType === VENDOR_USER_TYPE) {
          navigate("/facility-management/work-order-jobs");
        } else {
          navigate("/facility-management/tasks");
        }
        break;
      }

      case "Leasing":
        navigate("/leasing/tasks");
        break;

      case "Finance":
        navigate("/finance/tasks");
        break;

      case "Sales":
        navigate("/sales/tasks");
        break;

      case "Warehousing":
        navigate("/warehousing/tasks");
        break;

      default:
        break;
    }
  };

  return (
    <ReactSelect
      className="switch-app-dropdown"
      components={{
        ValueContainer,
        IndicatorSeparator: null,
        DropdownIndicator,
        Input,
        Option: CustomOption
      }}
      value={activeApp}
      onChange={handleChangeActiveApp}
      options={apps}
      isSearchable
    />
  );
}
